<mat-form-field class="w-100" appearance="fill">
  <mat-label>{{selectLabel ?? defaultSelectLabel}}</mat-label>
  <mat-select
    [panelClass]="panelClass"
    [(ngModel)]="userSelectedData"
    (openedChange)="openedChange($event)"
    [disabled]="isDisabled"
    multiple
  >
    <mat-select-trigger *ngLet="(userSelectedData | arrayMore : 2) as optionListValues">
      {{optionListValues.display}}
      <span *ngIf="optionListValues.more" class="additionalSelection">
        ({{StaticMessage.ArrayMoreText | staticMessage : optionListValues.more}})
      </span>
    </mat-select-trigger>
    <div class="optionsWrapper">
      <mat-option data-testId="option.name" *ngFor="let option of options" [value]="option.name" [disabled]="!canEdit">
        {{option.name}}
      </mat-option>
    </div>
    <footer class="d-flex align-items-center border-top py-2 px-3 buttonsWrapper">
      <button
        data-testId="apply"
        mat-flat-button
        class="mat-secondary"
        color="primary"
        (click)="onApply()"
        [disabled]="!canEdit"
      >
        <mat-icon svgIcon="check"></mat-icon>
        <span i18n="@@shared.multiselect.btnApply">Apply</span>
      </button>
      <button data-testId="cancel" mat-button color="primary" (click)="onCancel()">
        {{StaticMessage.CancelButton | staticMessage}}
      </button>
      <button
        data-testId="clear"
        *ngIf="userSelectedData?.length"
        mat-button
        color="primary"
        (click)="onClear()"
        [disabled]="!canEdit"
      >
        {{StaticMessage.ClearButton | staticMessage}}
      </button>
    </footer>
  </mat-select>
</mat-form-field>
